/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc factory
 * @name  DnsPolicyRuleConfig
 * @description
 *     DnsPolicyRuleConfig LegacyPolicyRuleConfigItem class, mapped to the protobuf message DnsRule.
 *     Used when configuring DNS Policy rules.
 */
const dnsPolicyRuleConfigFactory = (
        LegacyPolicyRuleConfigItem,
        DnsPolicyRuleTransportProtocolMatchConfig,
        DnsPolicyRuleQueryNameMatchConfig,
        DnsPolicyRuleQueryTypeMatchConfig,
        DnsPolicyRuleGeoLocationMatchConfig,
        DnsPolicyRuleClientIpMatchConfig,
        DnsPolicyRuleAllowDropActionConfig,
        DnsPolicyRuleResponseActionConfig,
        DnsPolicyRuleGslbSiteSelectionActionConfig,
        DnsPolicyRulePoolSwitchingActionConfig,
        DnsPolicyRuleRateProfileActionConfig,
        DnsPolicyRuleGsGroupSelectionActionConfig,
) => {
    class DnsPolicyRuleConfig extends LegacyPolicyRuleConfigItem {
        /**
         * The property of data#config#enabled in base class is renamed to 'enable' in DnsRule.
         * @override
         */
        setEnable(enable = true) {
            const config = this.getConfig();

            config.enable = enable;
        }
    }

    angular.extend(DnsPolicyRuleConfig.prototype, {
        type: 'DnsRule',
        matchSettingsHash: {
            client_ip_address: {
                className: DnsPolicyRuleClientIpMatchConfig,
                isRepeated: false,
                isNested: true,
            },
            protocol: {
                className: DnsPolicyRuleTransportProtocolMatchConfig,
                isRepeated: false,
                isNested: true,
            },
            query_name: {
                className: DnsPolicyRuleQueryNameMatchConfig,
                isRepeated: false,
                isNested: true,
            },
            query_type: {
                className: DnsPolicyRuleQueryTypeMatchConfig,
                isRepeated: false,
                isNested: true,
            },
            geo_location: {
                className: DnsPolicyRuleGeoLocationMatchConfig,
                isRepeated: false,
                isNested: true,
            },
        },
        actionSettingsHash: {
            allow: {
                className: DnsPolicyRuleAllowDropActionConfig,
                isRepeated: false,
                isNested: true,
            },
            response: {
                className: DnsPolicyRuleResponseActionConfig,
                isRepeated: false,
                isNested: true,
            },
            gslb_site_selection: {
                className: DnsPolicyRuleGslbSiteSelectionActionConfig,
                isRepeated: false,
                isNested: true,
            },
            pool_switching: {
                className: DnsPolicyRulePoolSwitchingActionConfig,
                isRepeated: false,
                isNested: true,
            },
            dns_rate_limiter: {
                className: DnsPolicyRuleRateProfileActionConfig,
                isRepeated: false,
                isNested: true,
            },
            gs_group_selection: {
                className: DnsPolicyRuleGsGroupSelectionActionConfig,
                isRepeated: false,
                isNested: true,
            },
        },
    });

    return DnsPolicyRuleConfig;
};

dnsPolicyRuleConfigFactory.$inject = [
        'LegacyPolicyRuleConfigItem',
        'DnsPolicyRuleTransportProtocolMatchConfig',
        'DnsPolicyRuleQueryNameMatchConfig',
        'DnsPolicyRuleQueryTypeMatchConfig',
        'DnsPolicyRuleGeoLocationMatchConfig',
        'DnsPolicyRuleClientIpMatchConfig',
        'DnsPolicyRuleAllowDropActionConfig',
        'DnsPolicyRuleResponseActionConfig',
        'DnsPolicyRuleGslbSiteSelectionActionConfig',
        'DnsPolicyRulePoolSwitchingActionConfig',
        'DnsPolicyRuleRateProfileActionConfig',
        'DnsPolicyRuleGsGroupSelectionActionConfig',
];

angular.module('aviApp').factory('DnsPolicyRuleConfig', dnsPolicyRuleConfigFactory);
